import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useFetch } from "@/hooks/useFetch";
import { inr } from "@/lib/format";

// Open projection LMs (LMPP) of the same customer; a PO LM booked against one reduces its balance.
export function ProjectionPicker({ customerId, value, onChange, testid }) {
  const { data } = useFetch(customerId ? `/projections/open?customer_id=${customerId}` : null);
  const rows = data || [];
  const cur = rows.find((p) => p.id === value);
  return (
    <>
      <Select value={value || "none"} onValueChange={(v) => onChange(v === "none" ? "" : v)} disabled={!customerId}>
        <SelectTrigger className="bg-white" data-testid={testid}><SelectValue placeholder={customerId ? "Not against a projection" : "Pick the customer first"} /></SelectTrigger>
        <SelectContent>
          <SelectItem value="none">Not against a projection</SelectItem>
          {rows.map((p) => <SelectItem key={p.id} value={p.id}>{p.order_no} · balance {inr(p.balance)} of {inr(p.subtotal)}</SelectItem>)}
          {value && !cur && <SelectItem value={value}>Linked projection</SelectItem>}
        </SelectContent>
      </Select>
      {customerId && !rows.length && <p className="text-[11px] text-slate-500 mt-1">No open projections for this customer</p>}
    </>
  );
}
